import { render, staticRenderFns } from "./CoNotFound.vue?vue&type=template&id=4c203f9d&scoped=true&"
import script from "./CoNotFound.vue?vue&type=script&lang=ts&"
export * from "./CoNotFound.vue?vue&type=script&lang=ts&"
import style0 from "./CoNotFound.vue?vue&type=style&index=0&id=4c203f9d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c203f9d",
  null
  
)

export default component.exports